module.exports = __webpack_public_path__ + "static/blob-88dc4ffb2db9781c30b0366eb0951416.png";